export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6732.1e45ccb7.jpg";